var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAncient = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M21.874 18.228c-1.162.346-2.378.52-3.601.518C13.38 18.746 9.316 7.6 8.453 4l-1.45 20.933c-.066.58.858 1.067 2.023 1.067H20.62c1.395 0 2.491-.595 2.372-1.287l-1.117-6.485Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M18.273 17.747c1.198.002 2.39-.166 3.53-.499L19.6 4c-.607 3.883-1.084 11.755-4.154 12.55.896.747 1.845 1.197 2.827 1.197ZM16.477 8.38 14.487 4l-1.991 4.38 1.99 3.994"
})));
export default SvgAncient;